import {styled} from '@linaria/react';
import React from 'react';
import {COLORS} from '../../../../constants/colors';
import {SPACING} from '../../../../constants/sizing';
import {Button, ButtonProps} from '../../ButtonsDeprecated/Button';

interface ContentPopperButtonsProps extends ButtonProps {
  label: string;
}

/* Used for Cancel Button */
export const PrimaryContentPopperButton: React.FC<
  ContentPopperButtonsProps
> = ({label, ...rest}) => {
  return (
    <StyledPrimaryButton
      type="primary"
      withBorder
      disableShadow
      aria-label={label}
      {...rest}
    >
      {label}
    </StyledPrimaryButton>
  );
};

/* Used for Cancel Button */
export const SecondaryContentPopperButton: React.FC<
  ContentPopperButtonsProps
> = ({label, ...rest}) => {
  return (
    <StyledSecondaryButton
      type="secondary"
      withBorder
      disableShadow
      aria-label={label}
      {...rest}
    >
      {label}
    </StyledSecondaryButton>
  );
};

const StyledPrimaryButton = styled(Button)`
  &&& {
    border: none;

    > span {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0;
      width: 100%;
      height: 100%;
      padding-inline: ${SPACING['X.Xl2']};
      border: none;
      white-space: nowrap;
    }
  }
`;

const StyledSecondaryButton = styled(Button)`
  width: 100%;
  padding-inline: ${SPACING['X.Xl2']};
`;

export const FooterWrapper = styled.div`
  background-color: ${COLORS['Fill.White']};
  display: flex;
  gap: ${SPACING['X.Lg']};
  padding: ${SPACING['Y.Lg']};

  & > * {
    // Default: secondary CTA takes 45%, primary CTA takes 55%
    // Use calc to account for gap and ensure buttons don't overflow
    &:first-child {
      flex: 0 0 calc(45% - ${SPACING['X.Lg']} / 2);
      // Allow shrinking if needed
      min-width: 0;
    }

    &:last-child {
      flex: 0 0 calc(55% - ${SPACING['X.Lg']} / 2);
      // Allow shrinking if needed
      min-width: 0;
    }

    // If only one child (secondary CTA), it takes full width
    &:only-child {
      flex: 1;
    }
  }
`;
